import shopCategory from '../../assetsPath/sections.data';


/* this value needs not to be changed */
const shopCategoryReducer = (state = shopCategory) => state;

export default shopCategoryReducer;